export default {
  name: 'AdropBox',
  props: {
    id: { type: String, default: () => (`a-drop-box-${Math.random().toString().substring(2)}`) },
    dragType: { type: String, default: () => 'text/plain' },
    draggable: { type: Boolean, default: () => false },
  },
  data() {
    return ({
      event: null,
    });
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    dragstart(a) {
      if (this.draggable) {
        a.dataTransfer.setData(this.dragType, this.id);
        this.$store.commit('setDragId', this.id);
        this.$emit('dragstart', a);
      }
    },
    dragenter(a) {
      a.preventDefault();
      this.$emit('dragenter', a);
    },
    dragleave(a) {
      a.preventDefault();
      this.$emit('dragleave', a);
    },
    dragover(a) {
      a.preventDefault();
      this.$emit('dragover', a);
    },
    dragend(a) {
      a.preventDefault();
      this.$emit('dragend', a);
    },
    drag(a) {
      a.preventDefault();
      this.$emit('drag', a);
    },
    drop(a) {
      a.preventDefault();
      a.stopPropagation();
      const { dragId, dropId } = this.$store.state;
      this.$emit('drop', { dragId, dropId });
      this.$nextTick(() => this.resize());
    },
    resize() {
      this.event = dispatchEvent(new Event('resize'));
    },
    revoke() {
      this.event = null;
    },
  },
  render() {
    return (
      <div
        id={this.id}
        class="a-drop-box"
        on-dragstart={this.dragstart}
        on-dragenter={this.dragenter}
        on-dragleave={this.dragleave}
        on-dragover={this.dragover}
        on-dragend={this.dragend}
        on-drag={this.drag}
        on-drop={this.drop}
      >
        {this.$slots.default}
      </div>
    );
  }
}